import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, Alert } from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';
import FormSection from './FormSection.jsx';
import PrincipalTable from './PrincipalTable.jsx';
import PrincipalForm from './PrincipalForm.jsx';

const PrincipalsStep = ({ formData = {}, updateFormData, validationErrors = {} }) => {
  const [principals, setPrincipals] = useState(formData.principals);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingPrincipal, setEditingPrincipal] = useState(null);
  const isInitialized = useRef(false);

  // Update parent formData when principals change
  useEffect(() => {
    if (updateFormData) {
      updateFormData({
        principals: principals
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional dependency list
  }, [principals]);

  // Sync local state with formData prop when navigating between steps
  useEffect(() => {
    if (formData && formData.principals && !isInitialized.current) {
      setPrincipals(formData.principals);
      isInitialized.current = true;
    }
  }, [formData]);

  const handleAddOwner = () => {
    setShowAddForm(true);
    setEditingPrincipal(null);
  };

  const handleEditPrincipal = (principal) => {
    setEditingPrincipal(principal);
    setShowAddForm(true);
  };

  const handleDeletePrincipal = (id) => {
    setPrincipals(principals.filter(p => p.id !== id));
  };

  const handleSavePrincipal = (principalData) => {
    if (editingPrincipal) {
      // Update existing principal
      setPrincipals(principals.map(p => 
        p.id === editingPrincipal.id ? { ...p, ...principalData } : p
      ));
    } else {
      // Add new principal
      const newPrincipal = {
        // id: Date.now(), // Simple ID generation
        ...principalData
      };
      setPrincipals([...principals, newPrincipal]);
    }
    setShowAddForm(false);
    setEditingPrincipal(null);
  };

  const handleCancelForm = () => {
    setShowAddForm(false);
    setEditingPrincipal(null);
  };

  const principalsError = validationErrors.principals || validationErrors['principals.0'];

  return (
    <Box sx={{ p: 3 }}>
      {principalsError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {principalsError}
        </Alert>
      )}
      {/* Principal Section */}
      <FormSection
        icon={<PersonIcon />}
        title="Principal"
        bgColor="blue.50"
      >
        <PrincipalTable
          principals={principals}
          onEdit={handleEditPrincipal}
          onDelete={handleDeletePrincipal}
        />
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            onClick={handleAddOwner}
            sx={{
              bgcolor: '#1976d2',
              '&:hover': { bgcolor: '#1565c0' },
              px: 3,
              py: 1,
              textTransform: 'none',
            }}
          >
            Add Owner
          </Button>
        </Box>

        {/* Add/Edit Principal Form */}
        {showAddForm && (
          <Box sx={{ mt: 3, pt: 3, borderTop: 1, borderColor: 'grey.200' }}>
            <PrincipalForm
              principal={editingPrincipal}
              onSave={handleSavePrincipal}
              onCancel={handleCancelForm}
            />
          </Box>
        )}
      </FormSection>

      {/* Principal Background Section */}
      {/* <FormSection
        icon={<ListIcon />}
        title="Principal Background"
        bgColor="grey.50"
      >
        <PrincipalBackground />
      </FormSection> */}

    </Box>
  );
};

export default PrincipalsStep;
